import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import Login from './Login';
export default function WebsiteBlogAuthorize() {
  const {user,loading}=useAuth();
  const location=useLocation();
  const [error,setError]=useState(''),[busy,setBusy]=useState(false);
  if(loading) return <main className="container py-5">Checking your TSLMS session…</main>;
  if(!user) return <div className="container py-4"><p className="alert alert-info">Sign into your existing TSLMS account to continue to website blog management.</p><Login returnTo={location.pathname+location.search}/></div>;
  const continueToWebsite=async()=>{
    setBusy(true);setError('');
    try {
      const params=new URLSearchParams(location.search);
      const response=await api.post('/website-blog/authorize',Object.fromEntries(params));
      const target=new URL(response.data.data.redirect);
      if(!['https:','http:'].includes(target.protocol)) throw new Error('Invalid callback.');
      window.location.assign(target.href);
    } catch(e) {setError(e.response?.data?.message || 'Could not authorise website access.');setBusy(false);}
  };
  return <main className="container py-5" style={{maxWidth:680}}><div className="card p-4 shadow-sm"><p className="text-primary">TOP SKILLED WEBSITE</p><h1 className="h3">Continue to blog management</h1><p>You are signed in as <strong>{user.firstName} {user.lastName}</strong>. Your TSLMS blog permissions apply on the website. Your password and existing LMS token will stay here.</p>{error&&<p role="alert" className="alert alert-danger">{error}</p>}<button className="btn btn-primary" disabled={busy} onClick={continueToWebsite}>{busy?'Continuing…':'Continue to website'}</button><Link className="mt-3" to="/dashboard">Cancel and return to TSLMS</Link></div></main>;
}
